import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { loadingSelector, headerSelector } from "../../selectors/layoutSelector";
import {
  instalacionSelector,
  usuarioSelector,
  sucursalSelector,
  resultadoAutenticacionSelector,
} from "../../selectors/sessionSelector";
import * as layoutActions from "../../reducers/layoutReducer/actions";
import * as sessionActions from "../../reducers/sessionReducer/actions";
import Layout from "../../components/Layout";

const LayoutContainer = ({
  usuario,
  instalacion,
  sucursal,
  loading,
  header,
  resultadoAutenticacion,
  sagaFetchUsuarioLogeado,
  sagaFetchInstalacion,
  sagaLogOutUsuario,
  initializeFormSession,
  setSucursal,
}) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  React.useEffect(() => {
    setDrawerOpen(false);

    // verifico si la instalación está identificada
    if (instalacion.datosContacto === undefined) {
      // busco la configuración de la instalación
      let url = encodeURIComponent(window.location.href);
      sagaFetchInstalacion(url);
    }

    //verifico si el usuario está logueado
    if (usuario === undefined) {
      sagaFetchUsuarioLogeado();
    }
  }, [instalacion.datosContacto, sagaFetchInstalacion, sagaFetchUsuarioLogeado, usuario]);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    localStorage.setItem("nombreBusqueda", "");
    setDrawerOpen(false);
  };

  const handleCerrarSession = () => {
    //Si no tiene un pedido en borrador cierro session y redirecciono al Login, si no pregunto si quiere seguir con el pedido

    //cierro session
    sagaLogOutUsuario();

    //Limpio los reductores
    //catalogo

    //session
    initializeFormSession();

    //Redirecciono al login
    window.location.hash = `/Login`;
  };

  const handleOnUsuarioAutenticado = () => {
    const idSucursalLocal = localStorage.getItem("sucursalSeleccionada") || undefined;
    if (usuario && usuario.sucursales?.length !== 0 && resultadoAutenticacion.autenticado) {
      let sucursalAux = usuario.sucursales.find((x) => x.idSucursal === parseInt(idSucursalLocal));
      if (sucursalAux) {
        setSucursal(sucursalAux);
        /*if(usuario && (usuario.idRol === 1 || usuario.idRol === 4)){
                    window.location.hash = '/Pedidos'
                    return
                }
                if(usuario && usuario.idRol === 2){
                    window.location.hash = '/Articulo'
                    return
                }*/
      } else {
        window.location.hash = "/SeleccionSucursal";
      }
    }
  };

  const handleOnUsuarioAutenticadoMemo = React.useCallback(handleOnUsuarioAutenticado, [
    resultadoAutenticacion.autenticado,
    setSucursal,
    usuario,
  ]);

  React.useEffect(() => {
    if (usuario && !sucursal) {
      handleOnUsuarioAutenticadoMemo();
    }
  }, [usuario, sucursal, handleOnUsuarioAutenticadoMemo]);

  return (
    <div>
      {/*!this.state.cargandoInstalacion && 
                <Layout 
                    drawerOpen={this.state.drawerOpen}
                    handleDrawerOpen={this.handleDrawerOpen}
                    handleDrawerClose={this.handleDrawerClose}
                    loading={this.props.loading}
                    header={this.props.header}
                />
            */}
      <Layout
        instalacion={instalacion}
        drawerOpen={drawerOpen}
        usuario={usuario}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        handleCerrarSession={handleCerrarSession}
        loading={loading}
        header={header}
        sucursal={sucursal}
      />
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...layoutActions,
      ...sessionActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    usuario: usuarioSelector(state),
    sucursal: sucursalSelector(state),
    instalacion: instalacionSelector(state),
    loading: loadingSelector(state),
    header: headerSelector(state),
    resultadoAutenticacion: resultadoAutenticacionSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutContainer);
